import React from 'react';
type BookCoverProps = {
  kicker: string;
  title: string;
  number?: string;
  accent?: string;
  size?: 'sm' | 'md';
  className?: string;
};

/**
 * Code-drawn cover in the product look: Night Navy, sunset glow at the
 * bottom, a top-down field and a colored spine.
 */
export function BookCover({
  kicker,
  title,
  number,
  accent = 'bg-gold',
  size = 'md',
  className = ''
}: BookCoverProps) {
  const sm = size === 'sm';
  return <div className={`relative aspect-[2/3] overflow-hidden rounded-[6px] border border-white/10 bg-navy shadow-book ${className}`} data-id="element-41" data-mp="2o780wtu0bht0">
      <span className="absolute inset-x-0 bottom-0 h-[55%] bg-gradient-to-t from-gold/45 via-gold/10 to-transparent" aria-hidden="true" data-id="element-42" data-mp="2eflpawdrbgpq" />
      {/* top-down mini field */}
      <svg viewBox="0 0 100 60" className="absolute bottom-[8%] left-[16%] right-[8%] w-[76%] opacity-70" aria-hidden="true" data-id="element-43" data-mp="24ho0a6o2pfw2">
        <rect x="1" y="1" width="98" height="58" rx="3" fill="#1F7A4D" stroke="#F7F7F2" strokeOpacity=".6" data-id="element-44" data-mp="20glz3kalitrg" />
        <line x1="50" y1="1" x2="50" y2="59" stroke="#F7F7F2" strokeOpacity=".6" data-id="element-45" data-mp="199g832m8c5zd" />
        <circle cx="16" cy="30" r="6" fill="none" stroke="#F7F7F2" strokeOpacity=".6" data-id="element-46" data-mp="1e32ewe5ppfn9" />
        <circle cx="84" cy="30" r="6" fill="none" stroke="#F7F7F2" strokeOpacity=".6" data-id="element-47" data-mp="zdwgutim1vgy" />
        <circle cx="35" cy="20" r="3.2" fill="#14213D" data-id="element-48" data-mp="14cpwarhgjwjr" />
        <circle cx="40" cy="40" r="3.2" fill="#14213D" data-id="element-49" data-mp="149bvvosctxey" />
        <circle cx="62" cy="26" r="3.2" fill="#4EA8DE" data-id="element-50" data-mp="1s2k773i7vb1d" />
        <circle cx="47" cy="30" r="2" fill="#F28C28" data-id="element-51" data-mp="1x03jhxvctdqo" />
      </svg>
      <span className={`absolute inset-y-0 left-0 w-[7%] ${accent}`} aria-hidden="true" data-id="element-52" data-mp="1wy9anhxcxc2y" />
      <div className="relative flex h-full flex-col py-[11%] pl-[16%] pr-[10%]" data-id="element-53" data-mp="1j0az0kaf7tr5">
        <p className={`font-semibold uppercase tracking-[0.18em] text-gold ${sm ? 'text-[6.5px] sm:text-[7.5px]' : 'text-[9px]'}`} data-id="element-54" data-mp="1n0utfg3m0j9l">
          {kicker}
        </p>
        {number && <p className={`mt-1 font-display font-bold leading-none text-white/15 ${sm ? 'text-3xl' : 'text-5xl'}`} data-id="element-55" data-mp="bkwgv2983f3m">
            {number}
          </p>}
        <p className={`mt-2 font-display font-bold uppercase leading-[0.95] text-white ${sm ? 'text-[12px] sm:text-[15px]' : 'text-[18px]'}`} data-id="element-56" data-mp="29bmif612cahh">
          {title}
        </p>
        <p className={`mt-2 font-semibold uppercase tracking-widest text-white/55 ${sm ? 'text-[5.5px] sm:text-[6.5px]' : 'text-[7.5px]'}`} data-id="element-57" data-mp="1zk8m174erqsk">
          No-Lines Lacrosse
        </p>
      </div>
    </div>;
}